import httpClient from './httpClient'

const AgencyApi = {
  async get(id) {
    try {
      const res = await httpClient.get(`/agency/${id}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  async searchAgency({
    keyword,
    agencyStatuses = ['active', 'inactive'],
    minPermissionLevel,
    pageNo,
    pageSize,
    sortKey,
    sortDirection,
  }) {
    if (agencyStatuses.length === 0) return { items: [], count: 0, pageNo: 1 }
    const status = (() => {
      if (
        agencyStatuses.includes('active') &&
        agencyStatuses.includes('inactive')
      )
        return undefined
      if (
        agencyStatuses.includes('active') ||
        agencyStatuses.includes('inactive')
      )
        return agencyStatuses[0]
      return undefined
    })()
    const reqBody = {
      query: {
        keyword,
        status,
        minPermissionLevel,
      },
      sortKey,
      sortDirection,
    }
    try {
      if (pageSize === undefined && pageNo === undefined) {
        const res = await httpClient.post('/agency/search/all', {
          ...reqBody,
        })
        return res.data
      }
      const res = await httpClient.post('/agency/search', {
        ...reqBody,
        pageNo,
        pageSize,
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async getAgencyMargins(id) {
    try {
      const res = await httpClient.get(
        `/agency/${id}/agency_margin/margin_value`,
      )
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
  async fetchAgencyAccountList(agencyId, { minPermissionLevel }) {
    try {
      const res = await httpClient.get(`/agency/${agencyId}/account`, {
        params: {
          min_permission_level: minPermissionLevel,
        },
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async addAgency({
    systemOwnerId,
    name,
    defaultAgencyMargin,
    email,
    paymentTerm,
    paymentTermDay,
    salesAccountId,
    timeZone,
  }) {
    try {
      return await httpClient.post('/agency', {
        systemOwnerId,
        name,
        defaultAgencyMargin,
        email,
        paymentTerm,
        paymentTermDay,
        salesAccountId,
        timeZone,
      })
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async editAgency(id, body) {
    try {
      return await httpClient.put(`/agency/${id}`, body)
    } catch (e) {
      console.log(e)
      throw e
    }
  },
}

export default AgencyApi
